<template>
    <div>
        <section class="ls-faq-list__section">
            <a testid="whatIsLawnStarter" @click="toggleQuestion('whatIsLawnStarter')"
                >What is {{ brand }}?<lsIconChevronRight
                    :class="[
                        whatIsLawnStarter ? 'ls-faq-list__chevron-down' : '',
                        'ls-faq-list__chevron',
                    ]"
            /></a>
            <p v-if="whatIsLawnStarter">
                {{ brand }} is an easy online and mobile app to order and manage lawn care services
                through. With in app communication for lawn care pros and support, you’ll never need
                anything (or anyone) else to take care of your lawn. Think of it as the Uber of lawn
                care!
            </p>
        </section>
        <section class="ls-faq-list__section">
            <a testid="servicing" @click="toggleQuestion('servicing')"
                >Who will be servicing my yard?<lsIconChevronRight
                    :class="[servicing ? 'ls-faq-list__chevron-down' : '', 'ls-faq-list__chevron']"
            /></a>
            <p v-if="servicing">
                We work with the top lawn care pros in your area. With a rigorous onboarding process
                for lawn care pros, only 20% of them who signup actually qualify for our platform.
                Shortly after you complete the signup process, we will assign one to you.
            </p>
        </section>
        <section class="ls-faq-list__section">
            <a @click="toggleQuestion('quality')"
                >How can I be sure of the quality of work?<lsIconChevronRight
                    :class="[quality ? 'ls-faq-list__chevron-down' : '', 'ls-faq-list__chevron']"
            /></a>
            <section v-if="quality">
                <p>
                    Check out any of our 200K+ 5-star reviews from happy customers! Since we work
                    hard to make sure our customers are satisfied, we’ve been able to resolve 84% of
                    lower star ratings and issues within 48-hours.
                </p>
                <p>
                    Not a fan of your assigned lawn care crew? Switch with the click of a button!
                </p>
                <p>Happy lawn, happy customer.</p>
            </section>
        </section>
        <section class="ls-faq-list__section">
            <a @click="toggleQuestion('howSoon')"
                >How soon can my lawn be mowed?<lsIconChevronRight
                    :class="[howSoon ? 'ls-faq-list__chevron-down' : '', 'ls-faq-list__chevron']"
            /></a>
            <p v-if="howSoon">
                We’re leading the industry with a 48-hour turnaround time from order date.
            </p>
        </section>
        <section class="ls-faq-list__section">
            <a @click="toggleQuestion('price')"
                >How did you price my lawn?<lsIconChevronRight
                    :class="[price ? 'ls-faq-list__chevron-down' : '', 'ls-faq-list__chevron']"
            /></a>
            <p v-if="price">
                We use public data (from Zillow) to get information about your house, lawn, and
                property size to make an accurate price for services. We’ve priced over 300K lots at
                a 97% accuracy rate.
            </p>
        </section>
        <section class="ls-faq-list__section">
            <a @click="toggleQuestion('payment')"
                >How does payment work?<lsIconChevronRight
                    :class="[payment ? 'ls-faq-list__chevron-down' : '', 'ls-faq-list__chevron']"
            /></a>
            <p v-if="payment">
                We only accept credit and debit cards, and charge 3-days after you receive the
                scheduled service. The delayed charge gives you time to make sure everything is up
                to your standards and gives us time to fix anything, if needed.
            </p>
        </section>
        <section class="ls-faq-list__section">
            <a class="ls-faq-list__home" @click="toggleQuestion('home')"
                >Do I have to be home for my service?<lsIconChevronRight
                    :class="[home ? 'ls-faq-list__chevron-down' : '', 'ls-faq-list__chevron']"
            /></a>
            <p v-if="home">
                Nope! You can even add notes for your provider if you have a gate, pet, and anything
                else to be aware of if you’re not home.
            </p>
        </section>
    </div>
</template>

<script>
import brandMixin from '@/mixins/brand.mixin';
import lsIconChevronRight from '../icons/lsIconChevronRight.vue';

export default {
    components: {
        lsIconChevronRight,
    },
    mixins: [brandMixin],
    data() {
        return {
            whatIsLawnStarter: false,
            servicing: false,
            quality: false,
            howSoon: false,
            price: false,
            payment: false,
            home: false,
        };
    },
    methods: {
        toggleQuestion(questionClicked) {
            this.whatIsLawnStarter =
                questionClicked === 'whatIsLawnStarter' && !this.whatIsLawnStarter;
            this.servicing = questionClicked === 'servicing' && !this.servicing;
            this.quality = questionClicked === 'quality' && !this.quality;
            this.howSoon = questionClicked === 'howSoon' && !this.howSoon;
            this.price = questionClicked === 'price' && !this.price;
            this.payment = questionClicked === 'payment' && !this.payment;
            this.home = questionClicked === 'home' && !this.home;
        },
    },
};
</script>

<style lang="scss" scoped>
a {
    font-weight: bold;
    font-size: 0.875rem;
    display: flex;
    justify-content: space-between;
}
p {
    margin-top: 0.5rem;
    font-size: 0.875rem;
    color: #798d84;
}
.ls-faq-list__chevron {
    max-height: 15px;
    width: 10px;
    margin-left: 8px;
    vertical-align: middle;
}
.ls-faq-list__chevron-down {
    transform: rotate(90deg);
}
.ls-faq-list__section {
    padding: 5px;
    user-select: none;
}

.themed-app {
    a {
        color: $theme-color-gray-darker;
    }
    p {
        color: $theme-color-gray-darker;
    }
}
</style>
